import {
  AppraisalFormLMProps,
  ApproveAppraisalFormType,
} from 'Pages/Frontend/Interface/Admin/AppraisalsAdmin/AppraisalsAdminDetails/AppraisalsAdminDetails'
import { AppraisalsSettingsFormType } from 'Pages/Frontend/Interface/Admin/AppraisalsAdmin/AppraisalsAdmin'
import { AppraisalFormProps } from 'Pages/Frontend/Interface/EmployeeManager/AppraisalForm/AppraisalForm'
import axios from 'axios'

export const appraisalService = {
  index: async (pageNumber: number, year: string | undefined, quarter: number | undefined) => {
    const queryParams: string[] = [`pageNumber=${pageNumber}`]

    if (year) queryParams.push(`year=${year}`)
    if (quarter) queryParams.push(`quarter=${quarter}`)

    return await axios.get(`admin/appraisals?${queryParams.join('&')}`)
  },
  settings: async () => {
    return await axios.get('admin/settings')
  },
  managerIndex: async (year: string | undefined, quarter: number | undefined) => {
    const queryParams: string[] = []

    if (year) queryParams.push(`year=${year}`)
    if (quarter) queryParams.push(`quarter=${quarter}`)

    return await axios.get(`appraisals/subordinates?${queryParams.join('&')}`)
  },

  employeeIndex: async (year: string | undefined) => {
    if (year) {
      return await axios.get(`appraisals?year=${year}`)
    } else {
      return await axios.get('appraisals')
    }
  },
  getSingleAdmin: async (id: string) => {
    return await axios.get(`admin/appraisals?id=${id}&pageNumber=1`)
  },
  create: async (data: AppraisalFormProps) => {
    return await axios.post('appraisals', data)
  },

  updateManager: async (id: string | undefined, data: AppraisalFormLMProps) => {
    return await axios.post(`appraisals/subordinates/${id}`, data)
  },

  updateAdmin: async (data: ApproveAppraisalFormType) => {
    return await axios.post('/admin/appraisals/complete-appraisal', data)
  },

  startAppraisal: async (data: AppraisalsSettingsFormType) => {
    return await axios.post('admin/appraisals/settings', data)
  },

  downloadCsv: async () => {
    return await axios.get('appraisals/export-appraisal-csv', {
      responseType: 'blob'
    })
  },
}
